import React, { useCallback } from 'react';
export function AutocompleteOption(props) {
    const { children, id, onSelect, selected, value } = props;
    const handleClick = useCallback(() => {
        onSelect(value);
    }, [onSelect, value]);
    return (React.createElement("li", { "aria-selected": selected, "data-ui": "AutocompleteOption", id: id, role: "presentation", onClick: handleClick }, children));
}
//# sourceMappingURL=autocompleteOption.js.map